var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"id":_vm.params.id,"v-model":_vm.params.id,"name":_vm.params.name,"required":_vm.params.required,"type":"hidden"},domProps:{"value":_vm.params.value},on:{"change":_vm.change}})}
var staticRenderFns = []

export { render, staticRenderFns }